import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { bigblueIntegrationQuery } from "modules/settings/lib/bigblue/bigblueIntegrationQuery"
import {
  CreateIntegrationConfigurationSchema,
  DataResponse,
  UpsertBigBlueIntegrationSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CreateIntegrationConfigurationSchema>>

export function useUpsertBigBlueIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof UpsertBigBlueIntegrationSchema>) => {
      const response = await axios.post<Response>(`/integrations/bigblue/configuration`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bigblueIntegrationQuery().queryKey })
    },
  })
}
